export default __webpack_public_path__ + "static/media/entrepreneur-middle-east.2ea07976.png";